module.exports = __webpack_public_path__ + "img/add_theme_desktop_1.e863dd14.png";